// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tsE7y","delete":"styles_delete__3lLlC","update":"styles_update__ztrFj","add":"styles_add__16OWo"};